module.exports = __webpack_public_path__ + "img/pwa-android-3.f77ccdac.png";